// components/LoadingOverlay.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import '../../styles/loader.css'; // 질문에서 제시한 css 파일

const LoadingOverlay = ({ children }) => {
  const loading = useSelector((state) => state.ui.loading);

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ 
        filter: loading ? 'blur(2px)' : 'none', 
        pointerEvents: loading ? 'none' : 'auto' 
      }}>
        {children}
      </div>
      {loading && (
        <div 
          className="loader-container" 
          style={{ 
            position: 'fixed', 
            top: 0, left: 0, right: 0, bottom: 0, 
            backgroundColor: 'rgba(255,255,255,0.7)', 
            zIndex: 9999 
          }}
        >
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default LoadingOverlay;